import type { UserProfile } from '@shared/protocol';

interface Props {
  user: Pick<UserProfile, 'name' | 'picture' | 'hue'>;
  size?: 'sm' | 'lg';
}

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}

export function Avatar({ user, size = 'sm' }: Props) {
  const className = `avatar${size === 'lg' ? ' avatar--lg' : ''}`;

  if (user.picture) {
    return (
      <img
        className={className}
        src={user.picture}
        alt=""
        referrerPolicy="no-referrer"
        loading="lazy"
      />
    );
  }

  return (
    <span
      className={className}
      style={
        {
          '--avatar-bg': `oklch(0.42 0.09 ${user.hue})`,
          '--avatar-fg': 'oklch(0.97 0.02 90)',
        } as React.CSSProperties
      }
      aria-hidden
    >
      {initials(user.name)}
    </span>
  );
}
